import type { ReactNode } from 'react'
import { OverTheTopSection } from './OverTheTopSection'

type TabPageLayoutProps = {
  children: ReactNode
}

export const TabPageLayout = ({ children }: TabPageLayoutProps) => {
  return <div className='relative'>{children}</div>
}

TabPageLayout.OverTheTopSection = OverTheTopSection
